import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#070a12] text-slate-400 pt-16 pb-28 lg:pb-12 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-white shadow-lg overflow-hidden">
              <img src="/logo-icon.png" alt="" className="h-8 w-8 object-contain" />
            </span>
            <span className="font-display font-extrabold text-white text-lg">
              Instant Site<span className="text-yellow-400"> Revival</span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed">
            We bring outdated websites back to life fast and keep them running smoothly every month.
          </p>
        </div>

        <div>
          <div className="text-white font-bold text-sm mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#problems" className="hover:text-white">The Problem</a></li>
            <li><a href="#see-concept" className="hover:text-white">See Concept First</a></li>
            <li><a href="#process" className="hover:text-white">Process</a></li>
            <li><a href="#pricing" className="hover:text-white">Pricing</a></li>
            <li><a href="#care-plan" className="hover:text-white">Care &amp; Hosting Plan</a></li>
            <li><Link to="/social" className="hover:text-cyan-300 text-cyan-400 font-semibold">Social Media Care Package →</Link></li>
            <li><a href="#faq" className="hover:text-white">FAQ</a></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-bold text-sm mb-4">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/terms" data-testid="footer-terms-link" className="hover:text-white">Terms of Service</a></li>
            <li><a href="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy Policy</a></li>
            <li><a href="#care-plan" className="hover:text-white">Care Plan Terms</a></li>
          </ul>
          <div className="mt-5 rounded-xl bg-white/5 border border-white/5 p-4 text-xs leading-relaxed text-slate-400">
            <span className="text-white font-bold">You own your website.</span> Care &amp; Hosting
            Plan is month-to-month. Cancel anytime — hosting &amp; support stop, but we can hand
            off your website files.
          </div>
        </div>

        <div>
          <div className="text-white font-bold text-sm mb-4">Get in touch</div>
          <a
            href="https://wa.me/17865756919"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white font-bold px-4 py-2.5 text-sm hover:bg-[#1eb558] transition"
          >
            <MessageCircle size={16} /> Message Us · 786-575-6919
          </a>
          <div className="mt-4 text-sm">
            <a href="mailto:info@instantsiterevival.com" className="hover:text-white" data-testid="footer-email-link">
              info@instantsiterevival.com
            </a>
          </div>
          <div className="mt-2 text-sm text-slate-500">InstantSiteRevival.com</div>
          <div className="mt-5 space-y-1 text-xs text-slate-400">
            <div>Website Build Special: <span className="text-yellow-400 font-bold">$750</span> <span className="text-slate-500 line-through">$1,499</span></div>
            <div>Care &amp; Hosting Plan: <span className="text-white font-bold">$99/month</span></div>
          </div>
        </div>
      </div>

      <div className="mt-12 max-w-7xl mx-auto px-5 lg:px-8 text-xs text-slate-500 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div>© {new Date().getFullYear()} Instant Site Revival. All rights reserved.</div>
        <div>Same-day launch available after approval when all required information and access are ready.</div>
      </div>
    </footer>
  );
}
